module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_0@2x.4e84520c.png";